<template>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
        :destroy-on-close="true" title="调整文件顺序" append-to-body width="90%"
        class="drag-ghost-wrap-daily-task-dialog dialog-body-border-bottom modal-body-padding-bottom-10"
        :before-close="handleClose">
        <el-alert title="此处文件顺序影响到邮件中文件的排序顺序" type="error" :closable="false">
        </el-alert>
        <div class="content-wrap pb20" style="max-height: 50vh;overflow-y: auto;">
            <Draggable :list="droplist" ghost-class="drag-ghost" dragClass="dragClass" class="drag-ghost-list"
                group="field">
                <div class="drag-ghost-item" v-for="(item, index) in droplist" :key="item.task_detail_id">
                    <p class="ellipsis-middle" :title="item.daily_file_name">{{ item.daily_file_name }}</p>
                    <span>{{ item.plat_name }}</span>
                    <i class="drag-ghost-item-badge">{{ index + 1 }}</i>
                </div>
            </Draggable>
        </div>
        <div slot="footer" class="dialog-footer tac pt8">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">保 存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Draggable from 'vuedraggable';
import { cloneDeep } from 'lodash'
export default {
    name: 'DropModal',
    components: {
        Draggable
    },
    props: {
        list: Array,
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                file_id: '',
                file_name: '',
                file_type: '',
                file_size: '',
                file_url: '',
            },
            droplist: [],
            cloneData: null,
            endData: null,
            isDrag: false
        }
    },
    mounted() {
        // let res_list = []
        // for (let i = 0; i < 30; i++) {
        //     res_list.push({
        //         id: i + 1,
        //         daily_file_name: `${i + 1}文件.txt`,
        //         plat_name: 'vivo'
        //     });
        // }
        // this.droplist = res_list;

        // this.droplist = cloneDeep(this.list)
    },
    methods: {
        handleDragend(evt) {
            const a = this.droplist.findIndex((v) => v.task_detail_id === this.cloneData.task_detail_id)
            const b = this.droplist.findIndex((v) => v.task_detail_id === this.endData.task_detail_id);
            const list = [...this.droplist];
            if (b - a >= 0) {
                let slice_start = list.slice(a + 1, b + 1)
                list.splice(a, b - a, ...slice_start);
                list.splice(b, 1, this.cloneData);
            } else {
                let slice_start = list.slice(b, a)
                list.splice(b, 1, this.cloneData);
                list.splice(b + 1, a - b, ...slice_start);
            }
            this.droplist = list;
            this.isDrag = false;

            const draggedItem = evt.draggedContext.element;
            draggedItem.style.backgroundColor = 'yellow';
        },
        cloneDog(item) {
            this.cloneData = item;
        },
        log(evt) {
            this.endData = evt;
        },
        showModal() {
            this.droplist = cloneDeep(this.list)
            this.dialogVisible = true;
            this.$nextTick(() => {
                setTimeout(() => {
                   document.querySelectorAll('.ellipsis-middle').forEach(el => {
                        if (el.scrollHeight > el.clientHeight) {
                            el.classList.add('truncated');
                        }
                    }) 
                }, 10);
            });
        },
        setData() {
            this.form = this.data;
        },
        handleClose() {
            this.dialogVisible = false;
            this.$emit('close');
        },
        handleSubmit() {
            this.$emit('save', this.droplist);
            this.dialogVisible = false;
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep.drag-ghost-wrap-daily-task-dialog {
    .drag-ghost-list {
        display: flex;
        flex-wrap: wrap;
    }

    .drag-ghost {
        display: none;

        &.drag-ghost-item {
            border: 1px dashed #1e90ff !important;
            background-color: #ecf5ff !important;
        }

        .ellipsis-middle.truncated::after {
            background: linear-gradient(to right, transparent 10%, #ecf5ff 10%) !important;
        }

        p {
            color: #1e90ff;
        }

        span {
            color: #1e90ff !important;
        }
    }

    .drag-ghost-item {
        width: 10%;
        flex: 0 1 10%;
        height: 90px;
        border: 1px solid #ccc;
        background-color: #fff;
        border-radius: 4px;
        margin: 10px 5px 0 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;

        p {
            overflow: hidden;
            line-height: 1.5;
            position: relative;
            max-height: 3em;
            font-weight: 700;
            width: 90%;
            text-align: center;
            font-size: 14px;
        }

        .ellipsis-middle.truncated::after {
            content: "......";
            position: absolute;
            right: 0;
            bottom: 0;
            background: linear-gradient(to right, transparent 10%, #fff 10%);
            padding: 0px 5px;
            display: inline-block;
            transform: translateX(-65%);
        }

        .ellipsis-middle.truncated::after {
            display: block;
        }

        span {
            color: #9e9e9e;
        }

        .drag-ghost-item-badge {
            position: absolute;
            top: -5px;
            left: 0-5px;
            background-color: #f56c6c;
            border-radius: 10px;
            color: #fff;
            display: inline-block;
            font-size: 12px;
            height: 18px;
            line-height: 18px;
            padding: 0 6px;
            text-align: center;
            white-space: nowrap;
            border: 1px solid #fff;

        }

        &:hover {
            // background-color: #ecf5ff;
            // border: 1px solid #b3d8ff;
            background-color: #409EFF;
            border: 1px solid #409EFF;
            color: #fff;

            span {
                color: #fff;
            }

            .ellipsis-middle.truncated::after {
                background: linear-gradient(to right, transparent 10%, #409EFF 10%);
            }
        }
    }

    .dragClass {
        border: 1px solid #01AE97;
        border-radius: 8px;    
    }
}
</style>
